import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { Observable } from 'rxjs';
import { CompanyCollectorIdentifierRepository } from '@domain/company-collector-identifier/repositories/company-collector-identifier.repository';
import { CompanyCollectorIdentifierService } from '@core/services/entities/company-collector-identifier.service';
import { ListCompanyCollectorIdentifierRequestDto } from '@domain/company-collector-identifier/dtos/list-company-collector-identifier-request.dto';
import { CompanyCollectorIdentifierResponseDto } from '@domain/company-collector-identifier/dtos/company-collector-identifier.response.dto';
import { PageableResponse } from '@core/interface/pageable.interface';
import { CreateCompanyCollectorIdentifierRequestDto } from '@domain/company-collector-identifier/dtos/create-company-collector-identifier-request.dto';
import { RefId } from '@core/interface/ref-id.interface';

@Injectable({
  providedIn: 'root',
})
export class CompanyCollectorIdentifierRepositoryService
  implements CompanyCollectorIdentifierRepository
{
  constructor(
    private CompanyCollectorIdentifierService: CompanyCollectorIdentifierService,
  ) {}

  list(
    request: ListCompanyCollectorIdentifierRequestDto,
  ): Observable<
    ApiResponse<PageableResponse<CompanyCollectorIdentifierResponseDto>>
  > {
    return this.CompanyCollectorIdentifierService.list(request);
  }

  create(
    request: CreateCompanyCollectorIdentifierRequestDto,
  ): Observable<ApiResponse<CompanyCollectorIdentifierResponseDto>> {
    return this.CompanyCollectorIdentifierService.create(request);
  }

  delete(
    request: RefId,
  ): Observable<ApiResponse<CompanyCollectorIdentifierResponseDto>> {
    return this.CompanyCollectorIdentifierService.delete(request);
  }
}
